import React, { useEffect, useState } from "react";
import { ReactComponent as SelectType } from "../../../Global Icons/Select Type.svg";
import { useDispatch, useSelector } from "react-redux";
import { getBrandsList } from "../../../Redux/Actions/brandsActions";
import { ReactComponent as DropDown } from "../../../Global Icons/Dropdown Icon.svg";
import { ReactComponent as DropDownOpen } from "../../../Global Icons/DropDown Icon Open.svg";
import AddBrandsModal from "./addBrandsModal";

const BrandsNearbyDropdown = ({ onChange }) => {
  const dispatch = useDispatch();
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [dropDown, setDropDown] = useState(false);
  const [brandPop, setBrandPop] = useState(false);

  const { brands } = useSelector((state) => state.brands);

  const handleBrandChange = (e, brand) => {
    let updated = [];

    const alreadySelected = selectedBrands.some((b) => b._id === brand._id);

    if (e.target.checked && !alreadySelected) {
      updated = [
        ...selectedBrands,
        { _id: brand._id, name: brand.name, image: brand.image },
      ];
    } else {
      updated = selectedBrands.filter((b) => b._id !== brand._id);
    }

    setSelectedBrands(updated);
    if (onChange) {
      onChange(updated);
    }
  };

  const handleDropDown = () => {
    setDropDown(!dropDown);
  };

  const brandAddTrigger = () => {
    setBrandPop(!brandPop);
  };

  useEffect(() => {
    const payload = {
      page: 1,
      limit: 1000,
    };
    dispatch(getBrandsList(payload));
  }, [dispatch]);

  return (
    <div>
      <span style={{ fontSize: "14px" }}>
        Brands Nearby <span style={{ color: "red" }}>*</span>
      </span>
      <div className="border-10">
        <div>
          <div
            style={{ borderRadius: "10px 10px 0px 0px" }}
            onClick={() => handleDropDown()}
            className="flex-container align-center border-1-grey flex-justify-between padding-10 pointer"
          >
            <div className="flex-container align-center gap-5">
              <SelectType></SelectType>
              <span className="margin-0 p-bold">Select Brand</span>
            </div>
            {dropDown ? <DropDown></DropDown> : <DropDownOpen></DropDownOpen>}
          </div>
          {dropDown ? (
            <div
              style={{ height: "200px", borderRadius: "0px 0px 10px 10px" }}
              className="border-1-grey scroll-invisible overflowy-auto "
            >
              {Array.isArray(brands?.data) &&
                brands.data.map((brand) => {
                  const isSelected = Array.isArray(selectedBrands)
                    ? selectedBrands.some((b) => b._id === brand._id)
                    : false;

                  return (
                    <div
                      key={brand._id}
                      className="border-top-bottom flex-container align-center flex-justify-between margin-w-10 pointer"
                    >
                      <div className="padding-5 flex-container align-center">
                        <img
                          style={{ maxHeight: "20px" }}
                          src={brand.image}
                          alt={brand.name}
                        />
                        <p className="margin-10 p-bold">{brand.name}</p>
                      </div>
                      <input
                        className="pointer"
                        type="checkbox"
                        checked={isSelected}
                        onChange={(e) => handleBrandChange(e, brand)}
                        value={brand._id}
                      />
                    </div>
                  );
                })}

              <div className="flex-end align-center margin-10">
                <button
                  onClick={() => brandAddTrigger()}
                  className="button-class-white"
                >
                  Add Another Brand
                </button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {brandPop ? (
        <AddBrandsModal
          popTrigger={(newBrand) => {
            setBrandPop(false);
            if (newBrand) {
              const payload = {
                page: 1,
                limit: 2000,
              };
              dispatch(getBrandsList(payload));
            }
          }}
        ></AddBrandsModal>
      ) : null}
    </div>
  );
};

export default BrandsNearbyDropdown;
